import React, { useEffect, useMemo, useRef, useState } from 'react';
import './WalletView.scss';
import WalletLayout from '../../../Layouts/WalletLayout/WalletLayout';
import ThreeLine from '../../../Assets/icons/ThreeLine';
import MyTransactioncard from '../../../Components/Common/MyTransactionCard/MyTransactioncard';
import FilterTransactions from '../../../Components/Common/FilterTransactions/FilterTransactions';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    getChargingInvoice,
    getWalletTransactions,
    razorpayStatusRefresh,
    resetInvoiceDetails,
    resetWalletTransactions,
    setRazorpayRefresh,
    setWalletTransactions,
} from './redux/walletSlice';
import InvoiceDownload from '../../../Components/Common/InvoiceDownload/InvoiceDownload';
import Modal from '../../../Components/Common/Modal/Modal';
import PreLoader from '../../../Assets/icons/PreLoader/PreLoader';
import { Button } from '../../../Components/Common';
import InfiniteScroll from 'react-infinite-scroller';
import EmptyTrans from '../../../Assets/icons/EmptyTrans';
import { ToastContainer, toast } from 'react-toastify';
import { getHomeDetails } from '../HomeView/redux/homeSlice';
import chatBotIcon from '../../../Assets/icons/floatChatIcon.svg';
import { Pathname } from '../../../Router/Pathname';
import dayjs from 'dayjs';

const groupTransactionsByDate = (transactions) => {
    if (!Array.isArray(transactions) || !transactions.length) {
        return { Today: [], Yesterday: [], Older: {} };
    }
    const today = dayjs().format('YYYY-MM-DD');
    const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
    const groups = { Today: [], Yesterday: [], Older: {} };
    transactions.forEach((t) => {
        const date = dayjs(t.updatedAt).format('YYYY-MM-DD');
        if (date === today) groups.Today.push(t);
        else if (date === yesterday) groups.Yesterday.push(t);
        else {
            groups.Older[date] = groups.Older[date] || [];
            groups.Older[date].push(t);
        }
    });
    return groups;
};

const WalletView = () => {
    const { walletTransactions, hasMore, loading, page, success, invoiceDetails } = useSelector(
        (store) => store.wallet
    );
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [openFilter, setOpenFilter] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);

    const [refetchPaymentId, setRefetchPaymentId] = useState(null);
    const dispatch = useDispatch();

    const transactionId =
        searchParams.get('transactionId') || location?.state?.transactionId;
    const [isDisplayInvoice, setIsDisplayInvoice] = useState(false);
    const [showInvoicePolling, setShowInvoicePolling] = useState(false);

    const pollCountRef = useRef(0);

    const handleCloseInvoice = () => {
        setIsDisplayInvoice(false);
        setShowInvoicePolling(false);
        dispatch(resetInvoiceDetails());
        navigate(Pathname.WALLET, { replace: true, state: {} });
    };

    useEffect(() => {
        if (transactionId) {
            dispatch(resetInvoiceDetails());
            setShowInvoicePolling(true);
            dispatch(getChargingInvoice({ id: transactionId }));
        }
        return () => {
            dispatch(resetInvoiceDetails());
        };
    }, [transactionId, dispatch]);

    useEffect(() => {
        if (transactionId && invoiceDetails?.success === true) {
            setShowInvoicePolling(false);
            setIsDisplayInvoice(true);
        }
    }, [transactionId, invoiceDetails]);

    useEffect(() => {
        if (!transactionId || !showInvoicePolling) return;

        pollCountRef.current = 0;
        const MAX_POLLS = 10; // ~30 seconds polling timeout

        const invoiceInterval = setInterval(() => {
            pollCountRef.current += 1;
            if (pollCountRef.current >= MAX_POLLS) {
                clearInterval(invoiceInterval);
                setShowInvoicePolling(false);
                toast.error(
                    'Invoice is taking longer than expected. Please check your transaction history below.',
                    {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3500,
                    }
                );
                navigate(Pathname.WALLET, { replace: true, state: {} });
            } else {
                dispatch(getChargingInvoice({ id: transactionId }));
            }
        }, 3000);

        return () => {
            clearInterval(invoiceInterval);
        };
    }, [transactionId, showInvoicePolling, dispatch, navigate]);

    const groupedSections = useMemo(() => {
        const grouped = groupTransactionsByDate(walletTransactions);

        return [
            { label: 'Today', items: grouped.Today },
            { label: 'Yesterday', items: grouped.Yesterday },

            ...Object.entries(grouped.Older)
                .sort(([a], [b]) => b.localeCompare(a))
                .map(([date, items]) => ({
                    label: dayjs(date).format('D MMM YYYY'),
                    items,
                })),
        ];
    }, [walletTransactions]);

    const handleFilterOpen = () => {
        setOpenFilter(true);
    };
    const handlefilterClose = () => {
        setOpenFilter(false);
    };

    useEffect(async () => {
        let data = await dispatch(getHomeDetails());
        //   if (!data?.payload?.payload?.is_onboarded) {
        //         navigate('/userinfo');
        //     }
    }, []);

    useEffect(() => {
        //    if (hasMore) {
        dispatch(getWalletTransactions({ page: 0 }));
        dispatch(resetWalletTransactions());
        //    }
    }, [dispatch]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const loadMore = () => {
        if (!loading && hasMore) {
            dispatch(getWalletTransactions({ page: page }));
        }
    };

    const handleReload = async (id) => {
        // dispatch(resetWalletTransactions());

        setRefetchPaymentId(id);
        dispatch(setRazorpayRefresh(null));

        let res = await dispatch(razorpayStatusRefresh(id));
        console.log('res-->', res);
        if (res?.payload?.success) {
            setRefetchPaymentId(null);

            dispatch(setRazorpayRefresh(res?.payload));
            toast(`Payment Status - ${res?.payload?.payload?.paymentStatus}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                style: {
                    fontSize: '20px',
                },
            });

            const response = walletTransactions.map((transaction) => {
                console.log('transaction===>', transaction, res);
                if (transaction.order_id === id) {
                    return res?.payload?.payload?.tran;
                } else {
                    return transaction;
                }
            });

            console.log('res =====>', response);

            dispatch(setWalletTransactions([...response]));
            // dispatch(getWalletTransactions({ page: 0 }));
            // dispatch(resetWalletTransactions());
            // window.location.reload();
            // dispatch(getWalletTransactions({ page: 0 }));
        } else {
            setRefetchPaymentId(null);
            toast(res?.payload?.message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                style: {
                    fontSize: '20px',
                },
            });
        }
    };

    return (
        <WalletLayout>
            <section className="WalletView">
                <div className="WalletView--filter-btn">
                    <h1>My Transactions</h1>
                    {/* as figma design not functional right now for future ref. i commented it because it was breaking keeping handleopen and handleclose as it is ae well as filterTransactions*/}
                    
                    {/* <span className="WalletView--filter-icon" onClick={handleFilterOpen} aria-label="Filter transactions">
                        <ThreeLine />
                    </span> */}
                    <span>
                        <ThreeLine />
                    </span>
                </div>
                <div className="WalletView--transaction-history">
                    {!walletTransactions?.length ? (
                        <div className="WalletView--empty">
                            <EmptyTrans />
                        </div>
                    ) : (
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={loadMore}
                            hasMore={hasMore}
                            loader={
                                <div className="loader" key={0}>
                                    {/* Loading... */}
                                </div>
                            }
                        >
                            {groupedSections.map((section) =>
                                section.items.length > 0 ? (
                                    <div
                                        key={section.label}
                                        className="WalletView--transaction-group"
                                    >
                                        <h2 className="WalletView--transaction-group-title">
                                            {section.label}
                                        </h2>

                                        {section.items.map((el, ind) => (
                                            <div key={el?.id ?? el?.order_id ?? ind}>
                                                <MyTransactioncard
                                                    check_invoice={el.invoice_type}
                                                    transac_mode={el.mode}
                                                    handleReload={() => handleReload(el.order_id)}
                                                    requestedReloadPaymentId={refetchPaymentId}
                                                    paymentId={el?.external_payment_id}
                                                    orderId={el?.order_id}
                                                    amount={el?.amount}
                                                    station={
                                                        el?.chargingSession
                                                            ?.chargingStation
                                                            ?.station_name
                                                    }
                                                    mode={
                                                        el?.chargingSession
                                                            ?.charge_duration
                                                            ? el?.chargingSession
                                                                  ?.charge_duration
                                                            : '-'
                                                    }
                                                    lastChargingTime={el?.updatedAt}
                                                    element={
                                                        el?.chargingSession
                                                            ?.ocpp_transaction_id
                                                    }
                                                    txn_status={el.txn_status}
                                                    transactionTime={el?.updatedAt}
                                                    id={el?.id}
                                                    transaction={el}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                ) : null
                            )}
                        </InfiniteScroll>
                    )}

                    {/* <MyTransactioncard amount={'878'} /> */}
                </div>
                <ToastContainer />
                {/* ChatBot Icon */}
                <div className="chatBotIcon" onClick={() => navigate(Pathname.CHAT_BOT)}>
                    <img src={chatBotIcon} alt="Chat Bot Assistant Icon" />
                </div>
            </section>
            <FilterTransactions modalOpen={openFilter} modalClose={handlefilterClose} />

            {showInvoicePolling && (
                <Modal isOpen={showInvoicePolling} onClose={handleCloseInvoice} disableClose={false}>
                    <div className="WalletView--InvoicePolling">
                        <PreLoader />
                        <p className="loading-text">Please wait while fetching invoice</p>
                        <p className="cancel-btn" onClick={handleCloseInvoice}>
                            Cancel
                        </p>
                    </div>
                </Modal>
            )}

            {isDisplayInvoice && Boolean(invoiceDetails) && (
                <InvoiceDownload
                    openModal={isDisplayInvoice}
                    invoiceClose={handleCloseInvoice}
                    ocppTransactionId={transactionId}
                    invoiceId={''}
                />
            )}
        </WalletLayout>
    );
};

export default WalletView;
